module.exports = __webpack_public_path__ + "static/img/Retargeting-Selected.5758230.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Retargeting-Selected.png
// module id = 1581
// module chunks = 0